"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notAGitRepoResult = {
    success: false,
    message: 'fatal: not a git repository (or any of the parent directories): .git',
};
